import { createApp } from "vue/dist/vue.esm-bundler.js"; // for compiler build
import FlashMessage from "components/FlashMessage/index.vue";
import { addPlugins } from "./addPlugins.js";

document.addEventListener("DOMContentLoaded", () => {
  const element = document.getElementById("vue_flash_msg");

  const data = element.dataset;

  const app = createApp(FlashMessage, { ...data }); // passing data from rails to app

  addPlugins(app);
  app.mount("#vue_flash_msg");
});
